export default __webpack_public_path__ + "static/media/goods2.57984014.gif";